import { Box } from "@mui/material";
import { useState } from "react";
import TodayNotes from "./TodayNotes";
import TodayReminders from "./TodayReminders";
import TodaySales from "./TodaySales";
import TodayTasks from "./TodayTasks";

export enum TodayType {
    Sales = 1,
    Tasks = 2,
    Reminders = 3,
    Notes = 4,
}

export default function Today() {
    const [todayType, setTodayType] = useState(TodayType.Sales);

    const handleTypeChange = (type: TodayType) => {
        setTodayType(type);
    };

    return (
        <Box sx={{ overflow: "auto", height: "100%" }}>
            {todayType === TodayType.Sales && (
                <TodaySales type={todayType} onChange={handleTypeChange} />
            )}

            {todayType === TodayType.Tasks && (
                <TodayTasks type={todayType} onChange={handleTypeChange} />
            )}

            {todayType === TodayType.Reminders && (
                <TodayReminders type={todayType} onChange={handleTypeChange} />
            )}

            {todayType === TodayType.Notes && (
                <TodayNotes type={todayType} onChange={handleTypeChange} />
            )}
        </Box>
    );
}
